import React, { useEffect, useRef, useState } from "react";
import { Container, Images, Risk, Risks, Image, RiskItem } from "./styles";
import { useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import logoBranca from "./../../../images/logoBranca.png";
import { format } from "date-fns";
import { Button, Input, Modal, Spin } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import html2pdf from "html2pdf.js";

const { confirm } = Modal;

export default function CompanyForm() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1200px)",
  });

  const contentRef = useRef();

  const { company_id } = useParams();

  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [totalM, setTotalM] = useState(0);
  const [company, setCompany] = useState([]);
  const [error, setError] = useState("");
  const [integrating, setIntegrating] = useState("");
  const [visibleModalLink, setVisibleModalLink] = useState(false);
  const [sgg_id, setSgg_id] = useState("");

  useEffect(() => {
    loadingCompany();
  }, []);

  async function linkCompany() {
    if (!sgg_id) {
      toast.warn("Digite o código SGG da empresa");
      return;
    }
    setIntegrating(`link-company`);
    await api
      .put(`/sgg/company/${company_id}`, {
        sgg_id: sgg_id,
      })
      .then((response) => {
        toast.success("Vínculo realizado com sucesso");
        setVisibleModalLink(false);
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar vínculo");
        }
      });
    setIntegrating("");
  }

  async function integrationCompany() {
    setIntegrating(`company`);
    await api
      .post(`/sgg-company/${company_id}`, {
        razao_social: company.razao_social,
        cnpj: company.cnpj,
        nome_fantasia: company.nome_fantasia,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationSetor(sector) {
    setIntegrating(`sector-${sector.id}`);
    await api
      .post(`/sgg-sector/${sector.id}`, {
        setor: sector.name,
        company_id: company.id,
        descricao_ambiente: sector.description,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationFuncao(employee) {
    setIntegrating(`employee-${employee.id}`);
    await api
      .post(`/sgg-employee/${employee.id}`, {
        company_id: company.id,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function integrationRisks(sector) {
    setIntegrating(`risks-${sector.id}`);
    await api
      .post(`/sgg-risks/${sector.id}`, {
        company_id: company.id,
      })
      .then((response) => {
        toast.success("Integração realizada com sucesso");
        loadingCompany();
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao realizar integração");
        }
      });
    setIntegrating("");
  }

  async function loadingCompany() {
    await api
      .get(`/company/${company_id}`)
      .then((response) => {
        setCompany(response.data);
        let total = 0;
        let totalM = 0;
        response.data.companySector.map((item) => {
          item.companyEmployees.map((data) => {
            total += parseInt(data.quantidade_colaboradores) || 0;
            totalM += parseInt(data.quantidade_colaboradores_m) || 0;
          });
        });
        setTotal(total);
        setTotalM(totalM);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              setError(response.data.message);
              toast.warn(response.data.message);
            } else {
              setError("Erro Interno. verifique sua conexão e tente novamente");
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            setError("Erro Interno. verifique sua conexão e tente novamente");
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          setError("Erro Interno. verifique sua conexão e tente novamente");
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  const handleGeneratePdf = () => {
    const element = contentRef.current; // O elemento que queremos converter

    const options = {
      margin: 10,
      filename: `formulario-levantamento-${company_id}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true }, // scale 2 melhora a resolução
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    // Gera e baixa o PDF
    html2pdf().set(options).from(element).save();
  };

  return (
    <Container
      style={{
        minHeight: 80,
      }}
    >
      {!loading && (
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            justifyContent: "flex-end",
            marginTop: 30,
          }}
        >
          <Button
            type="primary"
            shape="round"
            onClick={handleGeneratePdf}
            style={{
              alignSelf: "flex-end",
            }}
          >
            Baixar PDF
          </Button>
        </div>
      )}

      <Container ref={contentRef}>
        {loading ? (
          <Spin size="large" style={{ marginTop: 50 }} />
        ) : (
          <>
            {error ? (
              <h3 style={{ marginTop: 100, textAlign: "center" }}>{error}</h3>
            ) : (
              <div
                style={
                  isDesktopOrLaptop
                    ? { padding: "20px", flexDirection: "column" }
                    : { maxWidth: "92%", width: "92%", flexDirection: "column" }
                }
              >
                <img src={logoBranca} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <h3 style={{ margin: 0 }}>Formulário EMPRESA</h3>
                  <div style={{ display: "flex", gap: "10px" }}>
                    {!company.sgg_id && (
                      <Button
                        type="primary"
                        onClick={() => {
                          setSgg_id("");
                          setVisibleModalLink(true);
                        }}
                      >
                        Vincular Código SGG
                      </Button>
                    )}
                    <Button
                      type="primary"
                      loading={integrating === `company`}
                      onClick={() => {
                        if (!company.sgg_id) {
                          confirm({
                            title: "Deseja integrar os dados da empresa?",
                            icon: <ExclamationCircleFilled />,
                            content:
                              "Essa ação enviará os dados da empresa para o SGG.",
                            okText: "Sim, integrar",
                            cancelText: "Cancelar",
                            onOk() {
                              integrationCompany("company");
                            },
                          });
                        }
                      }}
                      style={
                        company.sgg_id
                          ? { opacity: 0.7, cursor: "not-allowed" }
                          : {}
                      }
                    >
                      {company.sgg_id
                        ? `Id Empresa: ${company.sgg_id}`
                        : "Integrar Dados da Empresa"}
                    </Button>
                  </div>
                </div>
                <h4 style={{ margin: "20px 0 0 0" }}>DADOS DA EMPRESA</h4>
                <span style={{ margin: "20px 0 10px 0" }}>
                  Razão Social: <strong>{company.razao_social}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Nome Fantasia: <strong>{company.nome_fantasia}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  CNPJ / CAEPF: <strong>{company.cnpj}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Ramo de Atividade: <strong>{company.ramo_atividade}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  CEP: <strong>{company.cep}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Endereço: <strong>{company.endereco}</strong>
                </span>
                <h4 style={{ margin: "20px 0 15px 0" }}>RESPONSÁVEL</h4>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Nome do Responsável Assinante:{" "}
                  <strong>{company.nome_responsavel}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Número do CPF do Representante:{" "}
                  <strong>{company.cpf_responsavel}</strong>
                </span>
                <span style={{ margin: "5px 0 10px 0" }}>
                  Contato do Representante:{" "}
                  <strong>{company.contato_responsavel}</strong>
                </span>
                {company.companySector.map((item, index) => {
                  return (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        <h4 style={{ margin: 0 }}>SETOR {index + 1}</h4>
                        <Button
                          type="primary"
                          loading={integrating === `sector-${item.id}`}
                          onClick={() => {
                            if (!item.sgg_id) {
                              confirm({
                                title: "Deseja integrar este setor?",
                                icon: <ExclamationCircleFilled />,
                                content: `O setor "${item.name}" será integrado ao SGG.`,
                                okText: "Sim, integrar",
                                cancelText: "Cancelar",
                                onOk() {
                                  integrationSetor(item);
                                },
                              });
                            }
                          }}
                          style={
                            item.sgg_id
                              ? { opacity: 0.7, cursor: "not-allowed" }
                              : {}
                          }
                        >
                          {item.sgg_id
                            ? `Id Setor: ${item.sgg_id}`
                            : "Integrar Setor"}
                        </Button>
                      </div>
                      <span style={{ margin: "5px 0 0px 0" }}>
                        Nome: <strong>{item.name}</strong>
                      </span>
                      <span style={{ margin: "5px 0 10px 0" }}>
                        Descrição do Ambiente:{" "}
                        <strong>{item.description}</strong>
                      </span>
                      {item.companyEmployees.map((data, index) => {
                        return (
                          <>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: 20,
                                marginBottom: 10,
                              }}
                            >
                              <h5 style={{ margin: 0 }}>FUNÇÃO {index + 1}</h5>
                              <Button
                                type="primary"
                                loading={integrating === `employee-${data.id}`}
                                onClick={() => {
                                  if (!data.sgg_id) {
                                    confirm({
                                      title: "Deseja integrar esta função?",
                                      icon: <ExclamationCircleFilled />,
                                      content: `A função "${data.name}" será integrada ao SGG.`,
                                      okText: "Sim, integrar",
                                      cancelText: "Cancelar",
                                      onOk() {
                                        integrationFuncao(data);
                                      },
                                    });
                                  }
                                }}
                                style={
                                  data.sgg_id
                                    ? { opacity: 0.7, cursor: "not-allowed" }
                                    : {}
                                }
                              >
                                {data.sgg_id
                                  ? `Id Função: ${data.sgg_id}`
                                  : "Integrar Função"}
                              </Button>
                            </div>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Nome: <strong>{data.name}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Descrição das Atividades:{" "}
                              <strong>{data.description}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              EPIS usados na função:{" "}
                              <strong>{data.epis}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Quantidade colaboradores:{" "}
                              <strong>{data.quantidade_colaboradores}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Quantidade colaboradores masculinos:{" "}
                              <strong>{data.quantidade_colaboradores_m}</strong>
                            </span>
                            <span style={{ margin: "5px 0 0px 0" }}>
                              Quantidade colaboradores femininos:{" "}
                              <strong>{data.quantidade_colaboradores_f}</strong>
                            </span>
                          </>
                        );
                      })}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginTop: 20,
                          marginBottom: 10,
                        }}
                      >
                        <h5 style={{ margin: 0 }}>RISCOS DO SETOR</h5>
                        <Button
                          type="primary"
                          loading={integrating === `risks-${item.id}`}
                          onClick={() => {
                            if (!company.sgg_risks_id) {
                              const allIntegrated = item.companyScratchs.every(
                                (r) => r.sgg_id,
                              );
                              if (!allIntegrated) {
                                confirm({
                                  title: "Deseja integrar os riscos do setor?",
                                  icon: <ExclamationCircleFilled />,
                                  content:
                                    "Todos os riscos deste setor serão enviados para o SGG.",
                                  okText: "Sim, integrar",
                                  cancelText: "Cancelar",
                                  onOk() {
                                    integrationRisks(item);
                                  },
                                });
                              }
                            }
                          }}
                          style={
                            company.sgg_risks_id
                              ? { opacity: 0.7, cursor: "not-allowed" }
                              : {}
                          }
                        >
                          {company.sgg_risks_id
                            ? `Avaliação de Risco: ${company.sgg_risks_id}`
                            : "Integrar Riscos"}
                        </Button>
                      </div>
                      <Risks>
                        {item.companyScratchs.map((risk, riskIndex) => {
                          return (
                            <RiskItem key={riskIndex}>
                              <div className="risk-info">
                                <p style={{ margin: 0, marginBottom: 5 }}>
                                  <strong>
                                    Risco {risk.type} - {risk.name}
                                  </strong>
                                </p>
                                {risk.sgg_id && (
                                  <p style={{ margin: "5px 0" }}>
                                    Id Risco: <strong>{risk.sgg_id}</strong>
                                  </p>
                                )}
                                <p>
                                  <strong>Atividades/Processos:</strong>{" "}
                                  {risk.description}
                                </p>
                                {risk.fonte_geradora && (
                                  <p>
                                    <strong>Fonte Geradora:</strong>{" "}
                                    {risk.fonte_geradora}
                                  </p>
                                )}
                                {risk.perigos && (
                                  <p>
                                    <strong>Perigos:</strong> {risk.perigos}
                                  </p>
                                )}
                                {(risk.probabilidade || risk.efeito) && (
                                  <p>
                                    <strong>Avaliação de Risco:</strong> (
                                    {risk.probabilidade} x {risk.efeito})
                                  </p>
                                )}
                                {risk.epis && (
                                  <p>
                                    <strong>EPIs:</strong> {risk.epis}
                                  </p>
                                )}
                                {risk.epcs && (
                                  <p>
                                    <strong>EPCs:</strong> {risk.epcs}
                                  </p>
                                )}
                                {risk.medidas_controle && (
                                  <p>
                                    <strong>Medidas de Controle:</strong>{" "}
                                    {risk.medidas_controle}
                                  </p>
                                )}
                                {risk.tipo_exposicao && (
                                  <p>
                                    <strong>Tipo de Exposição:</strong>{" "}
                                    {risk.tipo_exposicao}
                                  </p>
                                )}
                                {risk.tempo_exposicao && (
                                  <p>
                                    <strong>Tempo de Exposição:</strong>{" "}
                                    {risk.tempo_exposicao}
                                  </p>
                                )}
                              </div>
                            </RiskItem>
                          );
                        })}
                      </Risks>
                      {!!company.companyImages[index].length && (
                        <>
                          <h5 style={{ margin: "20px 0 0 0" }}>
                            IMAGENS DO SETOR
                          </h5>
                          <Images style={{ justifyContent: "flex-start" }}>
                            {company.companyImages[index].map((item) => {
                              return (
                                <Image>
                                  <a href={item.photo_url} target="_blank">
                                    <img src={item.photo_url} />
                                  </a>
                                </Image>
                              );
                            })}
                          </Images>
                        </>
                      )}
                    </>
                  );
                })}

                <h4 style={{ margin: "35px 0 0px 0" }}>
                  Total de Funcionários: {total}
                </h4>
                <h4 style={{ margin: "5px 0" }}>
                  Total de Funcionários Femininos: {total - totalM || 0}
                </h4>
                <h4 style={{ margin: "0px 0 35px 0" }}>
                  Total de Funcionários Masculinos: {totalM}
                </h4>

                <h4 style={{ textAlign: "center", margin: "35px 0 5px 0" }}>
                  Guruseg Gestão e Treinamentos em Segurança do Trabalho:
                </h4>
                <a>www.guruseg.com.br</a>
                <h4 style={{ textAlign: "center", marginTop: 35 }}>
                  Apresentação:
                </h4>
                <span style={{ textAlign: "center", margin: "35px 0" }}>
                  Somos uma empresa especializada em Segurança do Trabalho
                  formada por Médicos especializados e uma equipe
                  multidisciplinar (Médicos, Engenheiros e Técnicos), focada na
                  qualidade agilidade dos serviços prestados aos nossos
                  clientes, somos referência em todo Brasil. Atuando na área de
                  Gestão ao E-social, elaboração e documentos, Treinamentos e
                  muito mais, contamos com unidades Franqueadas em todos os
                  estados Brasileiro.
                </span>

                {company.signature && (
                  <h4
                    style={{
                      color: "#000",
                      textAlign: "center",
                      maxWidth: "90%",
                      margin: "25px 0 50px 0",
                    }}
                  >
                    Formulário foi {company.signature} no dia{" "}
                    {format(
                      new Date(company.signature_date),
                      "dd/MM/yyyy HH:mm",
                    )}
                  </h4>
                )}
              </div>
            )}
          </>
        )}{" "}
      </Container>
      <Modal
        title="Vincular Código SGG"
        open={visibleModalLink}
        onOk={linkCompany}
        onCancel={() => setVisibleModalLink(false)}
        confirmLoading={integrating === "link-company"}
        okText="Vincular"
        cancelText="Cancelar"
      >
        <div style={{ padding: "20px 0" }}>
          <p>Digite o código SGG da empresa para realizar o vínculo manual:</p>
          <Input
            placeholder="Código SGG"
            value={sgg_id}
            onChange={(e) => setSgg_id(e.target.value)}
          />
        </div>
      </Modal>
    </Container>
  );
}
